/**
 * Admin Dashboard Service
 * Handles all dashboard-related admin API calls
 */

import { getApi } from '../adminApi';

/**
 * Get admin dashboard data
 * @returns {Promise}
 */
export const getAdminDashboard = async () => {
  return getApi('dashboard');
};

